export const UnCheckIcon = () => (
  <svg
    width="48"
    height="30"
    viewBox="0 0 48 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="30" rx="15" fill="#E9E9EB" />
    <g filter="url(#filter0_d_4430_55295)">
      <circle cx="15" cy="15" r="13" fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_d_4430_55295"
        x="0"
        y="0"
        width="30"
        height="30"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_4430_55295"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_4430_55295"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
